import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const PlusCircleIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<g opacity="0.8">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM17.12 11.96C17.12 12.33 16.81 12.63 16.44 12.63H12.62V16.46C12.62 16.83 12.31 17.13 11.94 17.13C11.57 17.13 11.27 16.83 11.27 16.46V12.63H7.55C7.18 12.63 6.87 12.33 6.87 11.96C6.87 11.59 7.18 11.28 7.55 11.28H11.27V7.57C11.27 7.19 11.57 6.89 11.94 6.89C12.31 6.89 12.62 7.19 12.62 7.57V11.28H16.44C16.81 11.28 17.12 11.59 17.12 11.96Z"
				/>
			</g>
		</svg>
	)
}

export default PlusCircleIcon
